const stepData = [
  "施設選択",
  "対象施設一覧/施設情報・異動状況登録",
  "内容確認",
  "機構へ提出",
];

const headList = [
  {
    headTitle: "施設名称",
  },
  {
    headTitle: "理由",
  },
  {
    headTitle: "廃止・休止・経営移管年月日",
  },
  {
    headTitle: "職員の異動状況",
  },
  {
    headTitle: "経営移管後の共済契約者名",
  },
  {
    headTitle: "廃止・休止が確認できる書類",
  },
];
export { stepData, headList };
